import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { colors } from "./colors";
import { Typography } from "./Typography";
import HubspotForm from "react-hubspot-form";
import { VideoFormQuery } from "../../fragments/NodeVideoFormFields";
import styled from "styled-components";
import { buttonStyles } from "./Buttons/WmkButton";
import LightbulbIcon from "./HeroVectors/LightbulbIcon";
import GearIcon from "./HeroVectors/GearIcon";
import HatIcon from "./HeroVectors/HatIcon";
import { FormContext } from "../context/FormContext";

const OverlayBackground = styled.div<{ open: boolean }>`
  // background: ${colors.darkPurple.getHex()};
  background: rgba(0, 0, 0, 0.1);
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 2;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 15vh 10vw;
  ${({ open }) =>
    open
      ? ``
      : `position: absolute;
      top: -200%;`};
  @media screen and (max-width: 576px) {
    padding: 0;
  }
`;

const FormPopupContainer = styled(Container)`
  background: ${colors.white.getHex()};
  padding: 3rem 0 8rem;
  z-index: 3;
  position: relative;
  overflow: hidden;
  .heading-col {
    text-align: center;
  }
  .hs-form-field {
    label {
      color: ${colors.textGray.getHex()};
      font-family: Nunito Sans;
      font-weight: 400;
      font-size: 16px;
      text-transform: uppercase;
    }
    .hs-input {
      width: 100%;
      border: 3px solid #e4effa;
    }
  }
  .form-col > div {
    &:nth-child(1) {
      height: 100%;
    }

    .row {
      height: fit-content;
    }
    div {
      height: 100%;
      form {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .hs-submit {
        height: fit-content;
      }
    }
    .input {
      height: fit-content;
    }
  }
  .hs-form {
    position: relative;
  }
  .hs-submit {
    input {
      ${buttonStyles}
    }
    height: fit-content;
    display: flex;
    justify-content: center;
    padding-top: 1rem;
  }
  form {
    margin: 0 10vw;
    height: 22rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // margin: 0 5vw
  }
  .form-col {
    height: 100%;
    & > div:nth-child(1) {
      height: 40vh;
    }
  }
  .lightbulb-icon {
    position: absolute;
    top: 2rem;
    left: 2rem;
    height: 13rem;
    width: auto;
  }
  .hat-icon {
    position: absolute;
    bottom: 0;
    right: 1rem;
    height: 10rem;
    width: auto;
    top: auto;
    left: auto;
  }
  .gear-icon {
    position: absolute;
    top: auto;
    bottom: -6rem;
    left: 15%;
    height: 12rem;
    width: auto;
  }
  @media screen and (max-width: 767px) {
    .gear-icon {
      position: absolute;
      top: -5rem;
      bottom: auto;
      left: -3.5rem;
      height: 12rem;
      width: auto;
    }
    .lightbulb-icon {
      display: none;
    }
    .hat-icon {
      bottom: -1rem;
    }
  }
`;

const FormPopup = ({ videoForm }: { videoForm: VideoFormQuery }) => {
  const [redirect, setRedirect] = useState(false);
  const [formUnlocked, setFormUnlocked] = useState(false);

  useEffect(() => {
    if (window && localStorage?.getItem("hasCompletedForm")) {
      setFormUnlocked(true);
    }
  }, []);

  useEffect(() => {
    if (redirect) {
      setTimeout(() => {
        window.location.href = `/courses/${videoForm.path}`;
      }, 500);
    }
  }, [redirect]);

  useEffect(() => {
    if (formUnlocked) {
      setRedirect(true);
    }
  }, [formUnlocked]);

  const handleForm = (event: MessageEvent) => {
    if (
      event.data.type === "hsFormCallback" &&
      event.data.eventName === "onFormSubmit"
    ) {
      if (event.data.id === videoForm.formId) {
        localStorage.setItem("hasCompletedForm", "true");
        setTimeout(() => {
          setFormUnlocked(true);
        }, 1000);
      }
    }
  };

  // const handleClick = (event: Event) => {
  //   if (event.target === event.currentTarget) {
  //     toggle();
  //   }
  // };

  useEffect(() => {
    window.addEventListener("message", handleForm);
    return () => {
      window.removeEventListener("message", handleForm);
    };
  }, []);

  return (
    // <HubUserContext.Consumer>
    //   {(data) => {
    //     const user = data && "user" in data ? data.user : null;

    // return !isValidUser(user) && !formUnlocked ? (
    <FormContext.Consumer>
      {(formContextData) => {
        return (
          <>
            <OverlayBackground
              onClick={(event) => {
                if (event.target === event.currentTarget) {
                  formContextData.toggleIsOpen();
                }
              }}
              open={formContextData.isFormOpen}>
              <FormPopupContainer fluid>
                <LightbulbIcon />
                <GearIcon />
                <HatIcon />
                <Row>
                  <Col className="heading-col">
                    <Typography.BLOCKQUOTE
                      style={{
                        color: colors.accentOrange.getHex(),
                        fontFamily: "Rajdhani",
                        fontSize: "18px",
                        margin: 0
                      }}>
                      {"Course Registration"}
                    </Typography.BLOCKQUOTE>
                    <Typography.H2
                      style={{
                        color: colors.black.getHex(),
                        fontSize: "40px"
                      }}>
                      {"Get Started Today"}
                    </Typography.H2>
                  </Col>
                </Row>
                <Row>
                  <Col className="form-col">
                    <HubspotForm portalId="526959" formId={videoForm.formId} />
                  </Col>
                </Row>
              </FormPopupContainer>
            </OverlayBackground>
          </>
        );
      }}
    </FormContext.Consumer>
    // ) : (
    //   <></>
    // );
    //   }}
    // </HubUserContext.Consumer>
  );
};

export default FormPopup;
